import styled from '@emotion/styled';
import { colorVariables, gutterSizes, fontSizes, lineHeights } from '../base/theme';

export const StyledTag = styled.div`
    display: flex;
    align-items: center;
    background: ${colorVariables.backgroundLight};
    border-radius: ${gutterSizes.small};
    padding: ${gutterSizes.small} ${gutterSizes.small} ${gutterSizes.small} ${gutterSizes.base};
    font-size: ${fontSizes.small};
    line-height: ${lineHeights.small};
    min-width: max-content;
`;

export const StyledCloseIcon = styled.div`
    margin-left: ${gutterSizes.small};
    cursor: pointer;
    display: flex;
    width: 17px;
    svg {
        width: 100%;
        height: auto;
    }
`;
